import { isValidObject as isValidObjectWithKeys } from './object'
import { ShippingOption } from '@afterpaytouch/portal-api/types'
import { shippingOptionKeys, Currency } from '../model'

import { Money } from '@afterpay/types'

export interface XbtInfo {
  exchangeRate: string
  currency: Currency
}

// eslint-disable-next-line
const stripNonShippingOptionKeys = (value: any): any => {
  return Object.keys(value)
    .filter((key) => shippingOptionKeys.includes(key))
    .reduce((mappedShippingOption, key) => {
      mappedShippingOption[key] = value[key]
      return mappedShippingOption
    }, {})
}

// eslint-disable-next-line
export const mapShippingOptions = (shippingOptions: any): ShippingOption[] => {
  if (!isValidObjectWithKeys(shippingOptions)) {
    return shippingOptions
  }

  const mappedShippingOptions = Object.values(shippingOptions)
    .map((value) => (isValidObjectWithKeys(value) ? stripNonShippingOptionKeys(value) : {}))
    .filter((mappedValue) => Object.keys(mappedValue).length > 0)

  return mappedShippingOptions
}

// eslint-disable-next-line
export const mapShippingOptionUpdate = (shippingOption: any): any => {
  if (isValidObjectWithKeys(shippingOption)) {
    return stripNonShippingOptionKeys(shippingOption)
  }

  return shippingOption
}

const convertCurrency = (amount: Money, xbtInfo: XbtInfo): Money => {
  return { amount: (parseFloat(amount.amount) / parseFloat(xbtInfo.exchangeRate)).toFixed(2), currency: xbtInfo.currency }
}

export const convertToXbtShippingOption = (shippingOption: ShippingOption, xbtInfo: XbtInfo): ShippingOption => {
  const newOption = {
    ...shippingOption,
    orderAmount: convertCurrency(shippingOption.orderAmount, xbtInfo),
    shippingAmount: convertCurrency(shippingOption.shippingAmount, xbtInfo),
  }
  if (shippingOption.taxAmount != null) {
    newOption.taxAmount = convertCurrency(shippingOption.taxAmount, xbtInfo)
  }
  return newOption
}

export const convertToXbtShippingOptions = (shippingOptions: ShippingOption[], xbtInfo: XbtInfo): ShippingOption[] => {
  return shippingOptions.map((option) => convertToXbtShippingOption(option, xbtInfo))
}
